import { WP_SERVICE } from "../../services/wp";
import { USER_TYPES } from "../types";

import MD5 from 'crypto-js/md5'

export function userLoginAction(credentials){
    return async (dispatch) => {
        dispatch(userLogin())
        
        await WP_SERVICE.wpLogin(credentials).then(result=>{
            localStorage.setItem("pwd", MD5(credentials.password))
            dispatch(userLoginSuccess(result))
        })
        .catch(error=>{
            dispatch(userLoginError())
        })

        
    }
}

const userLogin = () => ({
    type: USER_TYPES.USER_LOGIN,
    payload: true
})

const userLoginSuccess = (user) => ({
    type: USER_TYPES.USER_LOGIN_SUCCESS,
    payload: user
})

const userLoginError = () => ({
    type: USER_TYPES.USER_REGISTER_ERROR,
    payload: true
})

export function userLogoutAction(){
    return async (dispatch) => {
        dispatch(userLogout())
    }
}

const userLogout = () => ({
    type: USER_TYPES.USER_LOGOUT,
    payload:true
})